// UI & Init
const fields = {
  artist: {
    firstname: {
      element: document.getElementsByName('first-name')[0],
      rules: ['required']
    },
    lastname: {
      element: document.getElementsByName('last-name')[0],
      rules: ['required']
    },
    age: {
      element: document.getElementsByName('age')[0],
      rules: ['required']
    },
    county: {
      element: document.getElementsByName('county')[0],
      rules: ['required']
    },
    additionalneeds: {
      element: document.getElementsByName('additionalneeds')[0],
      rules: []
    }
  },
  parent: {
    name: {
      element: document.getElementsByName('parent-name')[0],
      rules: ['required']
    },
    email: {
      element: document.getElementsByName('parent-email')[0],
      rules: ['email']
    },
    phone: {
      element: document.getElementsByName('parent-phone')[0],
      rules: ['phone']
    },
    address: {
      element: document.getElementsByName('parent-address')[0],
      rules: ['required']
    },
    localauthority: {
      element: document.getElementsByName('localauthority')[0],
      rules: ['required']
    },
    eircode: {
      element: document.getElementsByName('parent-eircode')[0],
      rules: ['eircode']
    }
  }
};

function init() {
  // Setup event observers
  Object.keys(fields).forEach(group => {
    Object.keys(fields[group]).forEach(fieldKey => {
      const field = fields[group][fieldKey]
      // Events for input type fields
      field.element.addEventListener('focus', e => {
        validateUpTo(field)
      })
      field.element.addEventListener('input', e => {
        // Only "live"-validate a field if it's already marked as having an error
        if (field.element.classList.contains('has-errors')) {
          validateSingleField(field, group)
        }
        updateGroupValidity()
      })

      // Events for selectable lists (theme, medium, etc.)
      if (field.element.classList.contains('form_field-tags')) {
        field.element.querySelectorAll('li').forEach(button => {
          button.addEventListener('click', e => {
            if (field.element.classList.contains('has-errors')) {
              validateSingleField(field, group)
            }
            validateUpTo(field)
            updateGroupValidity()
          })
        })
      }
    })
  })

  document.getElementById('submit').addEventListener('click', e => {
    submit()
  })
}

init()

// Submit / Preview API
async function submit() {
  const endpoint = window.tiaHasEntry ? 'tia/update' : 'tia/submit'
  const validation = validateAll()
  if (validation.valid) {
    const data = gatherData()
    const response = await fetch(`${window.tiaHost}/${endpoint}`, { method: 'POST', body: data })
    window.location.href = window.location.href.replace('/submit', '/submit/art');
  } else {
    // Scroll to first issue
    validation.errors[0].field.element.scrollIntoView({ behavior: "smooth", block: "center"})
  }
}

function gatherData() {
  const result = new FormData()
  for (const group of Object.keys(fields)) {
    for (const fieldKey of Object.keys(fields[group])) {
      const field = fields[group][fieldKey]
      if (
          field.element.tagName.toLowerCase() !== 'div' &&
          field.element.type.toLowerCase() !== 'file' &&
          field.element.tagName.toLowerCase() !== 'select'
      ) {
        result.append(fieldKey, field.element.value)
      } else if (field.element.classList.contains('form_field-tags')) {
        const tags = []
        field.element.querySelectorAll('li.active').forEach(button => tags.push(button.dataset.value))
        result.append(fieldKey, tags)
      } else if (field.element.tagName.toLowerCase() === 'select') {
        const value = field.element.querySelector('option:checked').value
        result.append(fieldKey, value)
      }
    }
  }
  // Append files (special case because of processing)
  // Only append if a blob is present (useful for updating existing entries)
  if (window.artBlob) {
    result.append('art', window.artBlob, 'art.jpeg')
  }
  if (window.proofBlob) {
    result.append('proof', window.proofBlob, 'proof.jpeg')
  }

  // Append browser information
  const statInfo = {
    userAgent: navigator.userAgent,
    viewportWidth: window.innerWidth,
    viewportHeigth: window.outerWidth
  }

  result.append('statInfo', JSON.stringify(statInfo))

  return result
}

// Image Opening, Resizing, and Upload API
function loadArt(event) {
  const fileList = event.target.files;
  if (!fileList) {
    return
  }
  const file = fileList[0];
  const reader = new FileReader();
  reader.addEventListener('load', (event) => {
    // TODO: Integrate max-width / max-height settings from kirby
    const img = document.createElement('img')
    img.onload = loadEvent => {
      if (img.width > window.tiaMaxWidth) {
        let canvas = document.createElement('canvas')
        let width = img.width
        let height = img.height
        height *= window.tiaMaxWidth / width;
        width = tiaMaxWidth;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(blob => {
          window.artBlob = blob
          validateSingleField(fields.art.art)
          updateGroupValidity()
        }, 'image/jpeg');
      } else {
        window.artBlob = file
        validateSingleField(fields.art.art)
        updateGroupValidity()
      }
    }
    img.src = event.target.result
  });
  reader.readAsDataURL(file);
}

function loadProof(event) {
  const fileList = event.target.files;
  if (!fileList) {
    return
  }
  const file = fileList[0];
  const reader = new FileReader();
  reader.addEventListener('load', (event) => {
    // TODO: Integrate max-width / max-height settings from kirby
    // NOTE: THIS IS A PLACEHOLDER THAT DRAWS IMAGES INTO WEIRD SIZES
    const img = document.createElement('img')
    img.onload = loadEvent => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      canvas.toBlob(blob => {
      }, 'image/jpeg')
    }
    img.src = event.target.result
  });
  reader.readAsDataURL(file);
  window.proofBlob = file
  validateSingleField(fields.art.proof)
  updateGroupValidity()
}

// Top level validation functions
function validateAll() {
  var errors = []
  var valid = true
  Object.keys(fields).forEach(group => {
    Object.keys(fields[group]).forEach(fieldKey => {
      const field = fields[group][fieldKey]
      const result = validateField(field, group)
      if (!result.valid) {
        valid = false
        errors.push(result.error)
        field.element.classList.add('has-errors')
      } else {
        field.element.classList.remove('has-errors')
      }
    })
  })
  return { valid, errors }
}

function validateUpTo(currentField) {
  // Then do a partial validation that highlights broken fields before our current view
  var errors = []
  var valid = true
  for (const group of Object.keys(fields)) {
    for (const fieldKey of Object.keys(fields[group])) {
      const field = fields[group][fieldKey]
      if (field.element === currentField.element) {
        return
      }
      const result = validateField(field, group)
      if (!result.valid) {
        valid = false
        errors.push(result.error)
        field.element.classList.add('has-errors')
      } else {
        field.element.classList.remove('has-errors')
      }
    }
  }
}

function validateSingleField(field, group) {
  const result = validateField(field, group)
  if (!result.valid) {
    valid = false
    errors.push(result.error)
    field.element.classList.add('has-errors')
  } else {
    field.element.classList.remove('has-errors')
  }
}

function updateGroupValidity() {
  let invalidGroups = []
  Object.keys(fields).forEach(group => {
    Object.keys(fields[group]).forEach(fieldKey => {
      const field = fields[group][fieldKey]
      const result = validateField(field, group)
      if (!result.valid) {
        invalidGroups.push(group)
      }
    })
  })
  for (const group of Object.keys(fields)) {
    if (invalidGroups.indexOf(group) === -1) {
      document.getElementById(group + '-group').classList.add('valid')
    } else {
      document.getElementById(group + '-group').classList.remove('valid')
    }
  }
  if (invalidGroups.length === 0) {
    document.querySelector('.form_actions').classList.add('ready')
    document.getElementById('submit').classList.add('active')
  } else {
    document.querySelector('.form_actions').classList.remove('ready')
    document.getElementById('submit').classList.remove('active')
  }
}

function renderErrorMessages(error) {}

// Validation rules functions
function validateField(field, group) {
  var valid = true
  var error = {
    field: field,
    group: group
  }
  field.rules.forEach(rule => {
    switch (rule) {
      case 'required':
        valid = valid && (field.element.value !== '')
        error['reason'] = rule
        break
      case 'selection':
        // Selections are validated by checking whether one or more of the selectable fields in the selection
        // Have the "active" class set
        let hasValid = false
        for (const button of field.element.querySelectorAll('li')) {
          if (button.classList.contains('active')) {
            hasValid = true
          }
        }
        valid = valid && hasValid
        error['reason'] = rule
        break
      case 'artFile':
        if (window.tiaHasEntry) {
          valid = valid && true
        } else {
          valid = valid && window.artBlob
        }
        break
      case 'proofFile':
        if (window.tiaHasEntry) {
          valid = valid && true
        } else {
          valid = valid && window.proofBlob
        }
        break
      case 'eircode':
        valid = valid && (/^[a-zA-Z0-9\s+]{2,10}$/im.test(field.element.value))
        error['reason'] = rule
        break
      case 'phone':
        valid = valid && (/^[0-9\s+]{7,20}$/im.test(field.element.value))
        error['reason'] = rule
        break
      case 'email':
        valid = valid && (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(field.element.value.toLowerCase()))
        error['reason'] = rule
        break
      default:
        console.log(`Unknown rule ${rule}`)
        valid = false
        break
    }
  })
  if (!valid) {
    return { valid: false, error }
  } else {
    return { valid : true }
  }
}

// Validate entire form once on page load
// Fixes the issue with coming back to the form via the "preview" view
updateGroupValidity()
